require('./bootstrap');

window.Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar : true
});

$(document).ready(function(){
    $(document).find('[data-toggle="tooltip"]').tooltip();
});
